import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import captchaData from './jCaptchaController.json';

const base64ToBytes = (base64) => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  return bytes;
};

const getCaptcha = (req, res, ctx) => {
  return res(ctx.set('Content-Type', 'image/png'), ctx.body(base64ToBytes(captchaData.captchaBase64)));
};

export const handlers = [
  rest.post(getApiEndpoint('jCaptchaController/captcha'), withScenario(withAuthCheck(getCaptcha))),
];
